// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__31LxA","col":"CardReaderDesc_col__1SNS2","label":"CardReaderDesc_label__13w_T"};